import { Loader2, RefreshCw, LogOut, Inbox } from "lucide-react";
import { LOGO_URL } from "@/lib/constants";

const STATUSES = ["new", "contacted", "closed"];

const FilterBar = ({ filter, setFilter, counts }) => (
  <div className="flex flex-wrap gap-2 mb-6">
    {["all", ...STATUSES].map((s) => (
      <button
        key={s}
        onClick={() => setFilter(s)}
        className={`px-4 py-2 rounded-full text-sm font-bold capitalize border transition ${
          filter === s ? "bg-[#e10600] border-[#e10600] text-white" : "border-white/15 text-white/60 hover:text-white"
        }`}
        data-testid={`admin-filter-${s}`}
      >
        {s}{s !== "all" && counts[s] ? ` (${counts[s]})` : ""}
      </button>
    ))}
  </div>
);

const DashboardHeader = ({ leadsCount, onRefresh, onLogout }) => (
  <header className="sticky top-0 z-10 bg-black/85 backdrop-blur-xl border-b border-white/10">
    <div className="max-w-5xl mx-auto px-4 h-16 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <span className="bg-white rounded-xl px-2.5 py-1 inline-flex items-center">
          <img src={LOGO_URL} alt="Dent Xpress" className="h-7 w-auto" />
        </span>
        <h1 className="font-display font-bold text-lg">Leads</h1>
        {leadsCount !== null && <span className="text-xs text-white/40">({leadsCount} total)</span>}
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={onRefresh}
          className="inline-flex items-center justify-center w-9 h-9 rounded-full border border-white/15 hover:bg-white/5 transition"
          data-testid="admin-refresh-btn"
          aria-label="Refresh"
        >
          <RefreshCw className="w-4 h-4" />
        </button>
        <button
          onClick={onLogout}
          className="inline-flex items-center justify-center w-9 h-9 rounded-full border border-white/15 hover:bg-white/5 transition"
          data-testid="admin-logout-btn"
          aria-label="Logout"
        >
          <LogOut className="w-4 h-4" />
        </button>
      </div>
    </div>
  </header>
);

const LeadsList = ({ leads, filtered, renderCard }) => {
  if (!leads) {
    return (
      <div className="flex justify-center py-20">
        <Loader2 className="w-8 h-8 animate-spin text-white/40" />
      </div>
    );
  }
  if (filtered.length === 0) {
    return (
      <div className="flex flex-col items-center py-20 text-white/40" data-testid="admin-empty-state">
        <Inbox className="w-12 h-12 mb-3" />
        <p className="font-semibold">No leads here yet</p>
      </div>
    );
  }
  return <div className="space-y-4">{filtered.map(renderCard)}</div>;
};

export { FilterBar, DashboardHeader, LeadsList, STATUSES };
